import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom,Observable } from 'rxjs';
import { first,map,switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { State } from '../State';
import { getToken } from '../State/selectors/base.selectors';



export const API_METRICS = false;
export const API_TRACING = false;

@Injectable({
    providedIn: 'root',
})
export class ProtoApiService {
    constructor(protected router: Router, protected store: Store<State>, private http: HttpClient) {}
    //todo auch als Observable anbieten, damit das gecancelt werden kann
    Request<K, T>(body: K, decode: (v: Uint8Array) => T, encode: (v: K) => Uint8Array, path: string, resolverResponseRaw = false): Promise<T> {
        return firstValueFrom(this.store.select(getToken)).then((token) => {
            return new Promise((resolve, reject) => {
                const req = new XMLHttpRequest();
                req.onload = (e) => {
                    if (req.status === 200) {
                        // console.log(req)
                        // console.log(req.response)
                        if (resolverResponseRaw) {
                            resolve(req.response);
                        } else {
                            if (window['env'].useProtobuf) {
                                const response: T = decode(new Uint8Array(req.response));
                                resolve(response);
                            } else {
                                resolve(JSON.parse(req.response));
                            }
                        }
                    } else {
                        reject(req.response);
                    }
                };
                req.onerror = (err) => {
                    reject(err);
                };
                req.open('POST', environment.gatewayApiUrl + path);
                req.setRequestHeader('Authorization', 'Bearer ' + token);
                if (window['env'].useProtobuf) {
                    req.responseType = 'arraybuffer';
                    req.setRequestHeader('Content-Type', 'application/protobuf');
                    req.send(encode(body));
                } else {
                    req.responseType = 'text';
                    req.setRequestHeader('Content-Type', 'application/json');
                    req.send(JSON.stringify(body));
                }
            });
        });
    }
    Request$<K, T>(body: K, decode: (v: Uint8Array) => T, encode: (v: K) => Uint8Array, path: string, resolverResponseRaw = false): Observable<T> {
        return this.store.select(getToken).pipe(
            first(),
            switchMap((token) => {
                let headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);

                if (window['env']['useGzip']) {
                    headers = headers.set('Accept-Encoding', 'gzip');
                }
                if (window['env'].useProtobuf) {
                    headers = headers.set('Content-Type', 'application/protobuf');
                    return this.http.post(environment.gatewayApiUrl + path, encode(body).buffer, { headers, responseType: 'arraybuffer' }).pipe(
                        map((res) => {
                            return decode(new Uint8Array(res));
                        }),
                    );
                } else {
                    headers = headers.set('Content-Type', 'application/json');
                    return this.http.post(environment.gatewayApiUrl + path, JSON.stringify(body), { headers, responseType: 'text' }).pipe(
                        map((res) => {
                            return JSON.parse(res) as T;
                        }),
                    );
                }
            }),
        );
    }
}
